import { createScope } from './scope';
import { initHomeDemo } from './home-demo';
import { initHomeSections } from './home-sections';
import { initMarquee, initCardFit, initMosaic } from './home-layout-fx';
import { initFaqAccordion } from './faq-accordion';
import { initHomeTabs } from './home-tabs';

/**
 * 홈 페이지 인터랙션 시작. 반환값은 정리(cleanup) 함수.
 * 실행 순서는 원본 HTML 의 <script> 순서와 동일 (home-v2.js 가 가장 마지막에 시작되는 점 주의:
 * 히어로 탭 전환이 데모의 window.__demoPlay 를 호출하므로 데모가 먼저 준비되어야 함)
 */
export function initHome(root: HTMLElement) {
  const scope = createScope();
  initHomeDemo(root, scope);
  initHomeSections(root, scope);
  initMarquee(root, scope);
  initCardFit(root, scope);
  initFaqAccordion(root, scope);
  initMosaic(root, scope);
  initHomeTabs(root, scope);
  return () => scope.dispose();
}
